import { render, staticRenderFns } from "./DeleteRequests.vue?vue&type=template&id=1040d8d5&scoped=true&"
import script from "./DeleteRequests.vue?vue&type=script&lang=js&"
export * from "./DeleteRequests.vue?vue&type=script&lang=js&"
import style0 from "./DeleteRequests.vue?vue&type=style&index=0&id=1040d8d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1040d8d5",
  null
  
)

export default component.exports